// Body.jsx - Ceylon Wayfinder Premium Taxi Service Homepage
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './body.css';
import { FaShieldAlt, FaStar, FaClock, FaCar, FaUsers, FaMapMarkerAlt, FaPhoneAlt, FaCheckCircle } from 'react-icons/fa';




function Body() {
  const navigate = useNavigate();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isVisible, setIsVisible] = useState({});

  // Testimonials data
  const testimonials = [
    {
      text: "Excellent service! Punctual, professional, and very comfortable vehicles. Will definitely use again.",
      author: "Sarah Johnson",
      location: "United Kingdom",
      rating: 5
    },
    {
      text: "Best taxi service in Sri Lanka. Drivers are very knowledgeable about the routes and very friendly.",
      author: "Michael Chen",
      location: "Singapore",
      rating: 5
    },
    {
      text: "On time, clean cars, and great communication. Made our airport transfer stress-free.",
      author: "Elizabeth Williams",
      location: "Australia",
      rating: 5
    },
    {
      text: "Very reliable service. Booked for a week of tours and everything was perfect.",
      author: "David Thompson",
      location: "Canada",
      rating: 5
    }
  ];

  // Auto testimonial rotation
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            setIsVisible(prev => ({ ...prev, [entry.target.dataset.section]: true }));
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    const sections = document.querySelectorAll('.animate-section');
    sections.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Smooth scroll to section
  const scrollToSection = useCallback((sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);








// Professional SVG Icon Components (replacing emoji icons)
const CityToursIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-6 9 6v11a2 2 0 0 1-2 2h-5v-7H9v7H5a2 2 0 0 1-2-2V9z" />
    <path d="M9 22v-4h6v4" />
    <circle cx="12" cy="8" r="2" />
    <path d="M12 12v2" />
  </svg>
);

const RoundToursIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    <circle cx="12" cy="12" r="4" />
    <path d="M12 8a4 4 0 1 0 0 8" />
  </svg>
);

const CustomToursIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2a10 10 0 0 1 10 10c0 5.5-4 9-10 9" />
    <path d="M12 6v6l4 2" />
    <path d="M8 22h8" />
    <path d="M12 22v-3" />
  </svg>
);

const AirportIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.3c.4-.2.6-.6.5-1.1z" />
  </svg>
);










  return (
    <main className="cw-body">

      {/* ==================== HERO ==================== */}
<section
  className="cw-hero"
  style={{
    backgroundImage: `url(${process.env.PUBLIC_URL}/bannerceylonwayfinder.png)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}
>


        <div className="cw-hero-overlay"></div>
        <div className="cw-hero-content animate-fade-in">
          <span className="hero-welcome">Welcome to Ceylon Wayfinder</span>
          <h1 className="hero-title">
            Your Trusted<br />Travel Partner
          </h1>
          <p className="hero-subtitle">
            Premium, reliable & comfortable taxi services across Sri Lanka
          </p>
          <div className="hero-cta">
            <button 
              className="btn-primary" 
              onClick={() => navigate('/booking')}
              aria-label="Book your ride"
            >
              Book Your Ride
            </button>
            <button 
              className="btn-outline" 
              onClick={() => navigate('/services')}
              aria-label="View our services"
            >
              Our Services
            </button>
          </div>


        <div className="body-scroll-indicator">
          <span>Discover More</span>
          <div className="body-mouse">
            <div className="body-mouse-wheel"></div>
          </div>
        </div>

        </div>
      </section>

      {/* ==================== TRUST BADGES ==================== */}
      <div className="trust-badges">
        <div className="container">
          <div className="badges-grid">
            <div className="badge-item">
              <span className="badge-icon"><FaShieldAlt /></span>
              <div>
                <strong>Licensed & Insured</strong>
                <small>Fully Certified</small>
              </div>
            </div>
            <div className="badge-item">
              <span className="badge-icon"><FaStar /></span>
              <div>
                <strong>4.9/5 Rating</strong>
                <small>Customer Rated</small>
              </div>
            </div>
            <div className="badge-item">
              <span className="badge-icon"><FaUsers /></span>
              <div>
                <strong>10k+ Riders</strong>
                <small>Happy Customers</small>
              </div>
            </div>
            <div className="badge-item">
              <span className="badge-icon"><FaClock /></span>
              <div>
                <strong>24/7 Service</strong>
                <small>Always Available</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ==================== SERVICES SECTION ==================== */}
  <section id="services" className="animate-section services-section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Our Travel Services</span>
          <h2 className="section-title">Experience Sri Lanka Your Way</h2>
          <p className="section-subtitle">
            Discover handcrafted journeys designed for comfort, flexibility, and unforgettable experiences across the island.
          </p>
        </div>

        {/* Highlight Intro Points - 4 in one row */}
        <div className="services-intro-grid">
          <div className="intro-card animate-fade-up">
            <h3>Eco & Comfortable Travel</h3>
            <p>
              Enjoy smooth, eco-conscious transportation with modern comfort,
              ensuring a relaxed journey from start to finish.
            </p>
          </div>

          <div className="intro-card animate-fade-up delay-1">
            <h3>Instant Booking System</h3>
            <p>
              Book your ride or tour instantly with real-time confirmation and effortless scheduling.
            </p>
          </div>

          <div className="intro-card animate-fade-up delay-2">
            <h3>Transparent Pricing</h3>
            <p>
              No hidden charges — just clear, fair pricing so you always know what you pay.
            </p>
          </div>

          <div className="intro-card animate-fade-up delay-3">
            <h3>Island-Wide Coverage</h3>
            <p>
              From airports to beaches, hills to cities — we operate across every major destination in Sri Lanka.
            </p>
          </div>
        </div>

        {/* Main Services - 4 in one row with professional icons */}
        <div className="services-grid">
          {/* City Tours */}
          <div className="service-card hover-glow" onClick={() => navigate?.('/services?city-tours')}>
            <div className="service-icon">
              <CityToursIcon />
            </div>
            <h3>City Tours</h3>
            <p>
              Explore Sri Lanka's vibrant cities with guided travel experiences,
              covering culture, heritage sites, shopping areas, and iconic landmarks.
            </p>
            <span className="service-link">Explore Cities →</span>
          </div>

          {/* Round Tours */}
          <div className="service-card hover-glow" onClick={() => navigate?.('/services?round-tours')}>
            <div className="service-icon">
              <RoundToursIcon />
            </div>
            <h3>Round Tours</h3>
            <p>
              Experience complete island journeys covering beaches, mountains,
              wildlife parks, and cultural destinations in one seamless trip.
            </p>
            <span className="service-link">View Packages →</span>
          </div>

          {/* Custom Tours */}
          <div className="service-card hover-glow" onClick={() => navigate?.('/services?custom-tour')}>
            <div className="service-icon">
              <CustomToursIcon />
            </div>
            <h3>Custom Tours</h3>
            <p>
              Create your own travel itinerary. Choose destinations, duration,
              and style — we design a fully personalized travel experience for you.
            </p>
            <span className="service-link">Plan My Trip →</span>
          </div>

          {/* Airport Transfer */}
          <div className="service-card hover-glow" onClick={() => navigate?.('/services?airport')}>
            <div className="service-icon">
              <AirportIcon />
            </div>
            <h3>Airport Pickup & Drop</h3>
            <p>
              Fast, safe, and reliable airport transfers to and from Bandaranaike International Airport
              with professional drivers and comfortable vehicles.
            </p>
            <span className="service-link">Book Transfer →</span>
          </div>
        </div>
      </div>
    </section>



      {/* ==================== WHO WE ARE ==================== */}
      <section className="animate-section who-we-are">
        <div className="container grid-2">
          <div className="content-text">
            <span className="tag">About Us</span>
            <h2>Your Trusted Travel Partner Since 2021</h2>
            <p className="lead-text">
              Ceylon Wayfinder provides premium, reliable taxi services across Sri Lanka with professional drivers and well-maintained vehicles.
            </p>
            <p>
              Our commitment to excellence, safety, and customer satisfaction sets us apart. We understand that reliable transportation is essential for both travelers and locals alike.
            </p>
            <ul className="rich-bullets">
              <li>Professional, trained drivers</li>
              <li>Clean, well-maintained vehicles</li>
              <li>Transparent pricing</li>
              <li>24/7 customer support</li>
              <li>Real-time GPS tracking</li>
            </ul>
            <button className="btn-primary" onClick={() => navigate('/aboutus')}>
              Discover Our Story
            </button>
          </div>
          <div className="content-image">
            <img 
              src="/ceylon wayfinder.png" 
              alt="Ceylon Wayfinder Premium Fleet" 
              loading="lazy"
            />
            <div className="image-caption">Our Premium Fleet</div>
          </div>
        </div>
      </section>

      {/* ==================== WHY CHOOSE US ==================== */}
  <section className="animate-section why-choose">
  <div className="container">

    <div className="section-header">
      <span className="section-tag">Why Choose Us</span>
      <h2 className="section-title">Travel With Comfort, Safety & Confidence</h2>
      <p className="section-subtitle">
        We don’t just drive you — we deliver a smooth, safe, and unforgettable travel experience across Sri Lanka.
      </p>
    </div>

    <div className="why-grid">

      <div className="why-card">
        <div className="why-icon"><FaShieldAlt /></div>
        <h3>Verified Safety Standards</h3>
        <p>
          Every vehicle is fully licensed, regularly inspected, and maintained to
          ensure maximum safety on every journey. Your security is always our top priority.
        </p>
      </div>

      <div className="why-card">
        <div className="why-icon"><FaStar /></div>
        <h3>Highly Rated Experience</h3>
        <p>
          Trusted by thousands of travelers with consistent 4.9★ reviews for
          professionalism, comfort, and outstanding service quality.
        </p>
      </div>

      <div className="why-card">
        <div className="why-icon"><FaClock /></div>
        <h3>Reliable & Always On Time</h3>
        <p>
          We value your time. Our drivers ensure punctual pickups and smooth scheduling
          so your journey stays stress-free from start to finish.
        </p>
      </div>

    </div>
  </div>
</section>




      {/* ==================== FLEET PREVIEW ==================== */}
    <section className="animate-section fleet-section">
  <div className="container">

    <div className="section-header">
      <span className="section-tag">Discover Sri Lanka</span>
      <h2 className="section-title">Top Travel Destinations You Must Visit</h2>
      <p className="section-subtitle">
        Explore handpicked iconic locations filled with nature, culture, adventure, and unforgettable views.
      </p>
    </div>

    <div className="fleet-grid">

      <div className="fleet-card" onClick={() => navigate('/locations/sigiriya')}>
        <img src="/sigiriya.jpg" alt="Sigiriya" loading="lazy" />
        <div className="fleet-info">
          <h3>Sigiriya Rock Fortress</h3>
          <p>
            Ancient UNESCO World Heritage site with breathtaking sky-high views,
            frescoes, and royal history.
          </p>
          <small>Best time: Early morning | Culture • History</small>
          <span className="fleet-link">Explore Destination →</span>
        </div>
      </div>

      <div className="fleet-card" onClick={() => navigate('/locations/kandy')}>
        <img src="/kandy.webp" alt="Kandy" loading="lazy" />
        <div className="fleet-info">
          <h3>Kandy</h3>
          <p>
            The cultural capital of Sri Lanka, home to the sacred Temple of the Tooth
            and lush lake views.
          </p>
          <small>Best time: Evening walks | Culture • Heritage</small>
          <span className="fleet-link">Explore Destination →</span>
        </div>
      </div>

      <div className="fleet-card" onClick={() => navigate('/locations/ella')}>
        <img src="/ella.jpg" alt="Ella" loading="lazy" />
        <div className="fleet-info">
          <h3>Ella</h3>
          <p>
            Misty mountains, tea plantations, Nine Arches Bridge and one of the world’s
            most scenic train rides.
          </p>
          <small>Best time: Morning hikes | Nature • Adventure</small>
          <span className="fleet-link">Explore Destination →</span>
        </div>
      </div>

      <div className="fleet-card" onClick={() => navigate('/locations/galle')}>
        <img src="/gallefort.jpg" alt="Galle" loading="lazy" />
        <div className="fleet-info">
          <h3>Galle Fort</h3>
          <p>
            A beautiful colonial-era fort city surrounded by the ocean, cafes,
            and cobblestone streets.
          </p>
          <small>Best time: Sunset | History • Coastal</small>
          <span className="fleet-link">Explore Destination →</span>
        </div>
      </div>

      <div className="fleet-card" onClick={() => navigate('/locations/mirissa')}>
        <img src="/mirissa.jpg" alt="Mirissa" loading="lazy" />
        <div className="fleet-info">
          <h3>Mirissa Beach</h3>
          <p>
            Golden sandy beaches, whale watching tours, and calm tropical ocean vibes.
          </p>
          <small>Best time: November–April | Beach • Relax</small>
          <span className="fleet-link">Explore Destination →</span>
        </div>
      </div>

      <div className="fleet-card" onClick={() => navigate('/locations/nuwara-eliya')}>
        <img src="/nuwara-eliya.jpg" alt="Nuwara Eliya" loading="lazy" />
        <div className="fleet-info">
          <h3>Nuwara Eliya</h3>
          <p>
            “Little England” of Sri Lanka with cool climate, tea estates, waterfalls,
            and colonial charm.
          </p>
          <small>Best time: April season | Hills • Nature</small>
          <span className="fleet-link">Explore Destination →</span>
        </div>
      </div>

    </div>

    <div className="section-footer">
      <button className="btn-outline" onClick={() => navigate('/location')}>
        View All Destinations
      </button>
    </div>

  </div>
</section>





      {/* ==================== TESTIMONIALS ==================== */}
      <section className="animate-section testimonials-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Testimonials</span>
            <h2 className="section-title">What Our Customers Say</h2>
          </div>
          <div className="testimonial-slider">
            <div 
              className="testimonial-track"
              style={{ transform: `translateX(-${currentTestimonial * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div className="testimonial-item" key={index}>
                  <div className="testimonial-content">
                    <div className="quote-mark">"</div>
                    <p>{testimonial.text}</p>
                    <div className="testimonial-rating">
                      {'★'.repeat(testimonial.rating)}
                    </div>
                    <div className="author-info">
                      <strong>{testimonial.author}</strong>
                      <span>{testimonial.location}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="testimonial-dots">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${currentTestimonial === index ? 'active' : ''}`}
                  onClick={() => setCurrentTestimonial(index)}
                  aria-label={`View testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>


<div class="tripadvisor-section">
  <div class="tripadvisor-widget">
    <div class="tripadvisor-container" aria-label="TripAdvisor review widget">
      <div id="TA_cdswritereviewlg240" class="TA_cdswritereviewlg">
        <ul id="EcOVIF0KXjgb" class="TA_links LQdPUqgeM7">
          <li id="NYpdtI5r0" class="W5J9n4Lb95">
            <a target="_blank" rel="noopener noreferrer" 
              href="https://www.tripadvisor.com/Attraction_Review-g2645552-d33416695-Reviews-Chavo_Tours-Wellawaya_Uva_Province.html" 
              aria-label="Open TripAdvisor review page (opens in new tab)">
              <img 
                src="https://static.tacdn.com/img2/brand_refresh/Tripadvisor_lockup_horizontal_secondary_registered.svg" 
                alt="TripAdvisor"
              />
            </a>
          </li>
        </ul>
      </div>
      <script async 
        src="https://www.jscache.com/wejs?wtype=cdswritereviewlg&amp;uniq=240&amp;locationId=33416695&amp;lang=en_US&amp;display_version=2" 
        data-loadtrk onload="this.loadtrk=true"></script>
    </div>
  </div>

  <div class="tripadvisor-text">
    <h3>We are rated on TripAdvisor ⭐️</h3>
    <p>
      Guests love their time with Ceylon Wayfinder!  
      Drop your review and help more travelers discover unforgettable experiences.
    </p>
    <a class="review-btn" href="https://www.tripadvisor.com/Attraction_Review-g2645552-d33416695-Reviews.html" target="_blank">
      Write a Review →
    </a>
  </div>
</div>



      {/* ==================== FINAL CTA ==================== */}
      <section className="final-cta">
        <div className="container">
          <h2>Ready to Experience Premium Travel?</h2>
          <p className="cta-text">Book your ride with Ceylon Wayfinder today</p>
          <button className="btn-primary-large" onClick={() => navigate('/booking')}>
            Book Your Ride Now
          </button>
          <p className="cta-small">24/7 customer support • Free cancellation • Best price guarantee</p>
        </div>
      </section>





    </main>
  );
}

export default Body;